import { h, ComponentChildren, Fragment, RefObject } from "preact";
import { useState } from "preact/hooks";
import { Popover } from "./popover";
import { Icon } from "./icon";
import { setAnchor } from "services/anchors";
import "./dropdownbutton.scss";

// todo: splitbutton

// todo: need to provide some good way for the context menu (or whatever gets put in the popup) to close the popup

export interface DropdownButtonApi {
    close: () => void;
}

export interface DropdownButtonProps {
    api?: RefObject<DropdownButtonApi | undefined>;
    text: string;
    children?: ComponentChildren;
    id: string;
    disabled?: boolean;
    variant?: "default" | "primary" | "outline" | "text";
    size?: "default" | "small" | "medium" | "large";
    //color?: string;
    class?: string;
}

export const DropdownButton = (props: DropdownButtonProps) => {
    const css_variant = " " + (props.variant ?? "default");
    const css_size = (!props.size || props.size === "default") ? " medium" : (" " + props.size);
    const css_classes = "dropdownbutton" + css_variant + css_size + (!props.class ? "" : (" " + props.class));

    const [target, setTarget] = useState<string | null>(null);

    function close() {
        setTarget(null);
    }

    function onClick(e: h.JSX.TargetedMouseEvent<HTMLButtonElement>) {
        if (`--${e.currentTarget.id}` == target)
            setTarget(null);
        else
            setTarget(setAnchor(e.currentTarget));
    }

    function onToggle(newState: "open" | "closed") {
        if (newState !== "open") {
            setTarget(null);
        }
    }

    if (props.api) {
        props.api.current ??= {} as any;
        props.api.current!.close = close;
    }

    return (
        <Fragment>
            <button
                id={props.id}
                class={css_classes}
                disabled={props.disabled}
                onClick={onClick}>
                {
                    props.text
                }
                <Icon icon="chevron-down" />
            </button>
            <Popover visible={!!target} target={target} onToggle={onToggle}>
                {
                    props.children
                }
            </Popover>
        </Fragment>
    );
}
